import { render } from "./MenuLanguage.vue?vue&type=template&id=6469c52d&scoped=true&ts=true"
import script from "./MenuLanguage.vue?vue&type=script&lang=ts"
export * from "./MenuLanguage.vue?vue&type=script&lang=ts"

import "./MenuLanguage.vue?vue&type=style&index=0&id=6469c52d&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6469c52d"]])

export default __exports__